export const CV_FILE_NAME = "CV_Dario_Condori_Humerez.pdf";
export const CV_URL = `${process.env.PUBLIC_URL}/${CV_FILE_NAME}`;
